module.exports = __webpack_public_path__ + "static/media/Sample_Thermocycler.3feb6dc2.svg";